import { useTranslation } from "react-i18next"

import { TabsList, TabsTrigger } from "@/components/ui/tabs"

import type { IntakeStage } from "@/features/intake/lib/intake-status"

export type IntakeTab = "ALL" | IntakeStage

const TAB_ORDER: IntakeTab[] = [
  "ALL",
  "PENDING",
  "SCALE",
  "QUALITY",
  "COMPLETED",
]

interface IntakeTabBarProps {
  counts: Record<IntakeTab, number>
}

export function IntakeTabBar({ counts }: IntakeTabBarProps) {
  const { t } = useTranslation("intake")

  const labelFor = (key: IntakeTab) => {
    if (key === "ALL") return t("tabs.all")
    if (key === "PENDING") return t("tabs.pending")
    if (key === "SCALE") return t("tabs.scale")
    if (key === "QUALITY") return t("tabs.quality")
    return t("tabs.completed")
  }

  return (
    <TabsList variant={"line"} className="justify-start gap-6">
      {TAB_ORDER.map((tab) => (
        <TabsTrigger
          key={tab}
          value={tab}
          // className="flex-none gap-2 px-1 text-[11px] font-semibold tracking-wide uppercase"
        >
          {labelFor(tab)}
          <span className="inline-flex">
            {counts[tab] ? `(${counts[tab]})` : ""}
          </span>
        </TabsTrigger>
      ))}
    </TabsList>
  )
}
